import { render, staticRenderFns } from "./BusRiskAreaConfigList.vue?vue&type=template&id=57025244&scoped=true&"
import script from "./BusRiskAreaConfigList.vue?vue&type=script&lang=js&"
export * from "./BusRiskAreaConfigList.vue?vue&type=script&lang=js&"
import style0 from "./BusRiskAreaConfigList.vue?vue&type=style&index=0&id=57025244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57025244",
  null
  
)

export default component.exports